// ============================================
// PUNTO DE ENTRADA DE REACT
// ============================================
// Este archivo monta la aplicación React en el DOM

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './services/requestTracker';  // ✅ F52-D: Activar tracking global de requests (antes que cualquier service)
import './index.css'  // Importar estilos globales (incluye Tailwind)
import './global.css';
import App from './App.jsx'

// Obtener el elemento del DOM donde se montará React
// Este div#root está en /index.html
const rootElement = document.getElementById('root');

// Crear la raíz de React y renderizar la aplicación
createRoot(rootElement).render(
  // StrictMode activa verificaciones adicionales en desarrollo
  // Ayuda a detectar problemas potenciales en la aplicación
  <StrictMode>
    <App />
  </StrictMode>,
)
